import {
  ChangeDetectionStrategy,
  Component,
  HostBinding,
  OnInit,
} from '@angular/core';
import { UrlUtilsService } from '../../services/url-utils/url-utils.service';

@Component({
  selector: 'rd-core-home-page',
  templateUrl: './home-page.component.html',
  styleUrls: ['./home-page.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class HomePageComponent implements OnInit {
  @HostBinding('class.rd-core-home-page') componentClass = true;

  travelEdgeUrl: URL;

  constructor(private urlUtilsService: UrlUtilsService) {}

  ngOnInit(): void {
    this.travelEdgeUrl = this.urlUtilsService.travelEdgeUrl('');
  }

  backgroundImageStyle(): { [key: string]: string } {
    return {
      'background-image': `url(${this.urlUtilsService.imageUrl(
        '/images/rd_banner.jpg',
      )})`,
    };
  }
}
